module.exports = __webpack_public_path__ + "media/images/athletes/1795-99d82c9710c0b7c625015cfce1b657b5.png";